<button class="menu" [class.on]="_base.menuOpen$ | async" aria-label="打開選單">
  <span></span>
</button>
